import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { map, filter } from 'lodash';

import CheckList from '~/components/base/CheckList';

import { formatText } from '~/utilities/helpers';

import {
    h1,
    h2,
    h3,
    h4,
    p,
    small,
    medium,
    large,
    a,
    ul,
    ol,
    li
} from '~/styles/typography';
import { button } from '~/styles/buttons';
import { setSmallSpacing } from '~/utilities/spacing';

const StyledDiv = styled.div`
    h1 {
        ${h1};
        margin-bottom: 10px;
    }
    h2 {
        ${h2};
        margin-bottom: 10px;
    }
    h3 {
        ${h3};
        margin-bottom: 10px;
    }
    h4 {
        ${h4};
        margin-bottom: 10px;
    }
    p {
        ${p};

        &:not(:last-of-type) {
            ${setSmallSpacing('margin-bottom')}
        }
    }
    .small {
        ${small};
    }
    .medium {
        ${medium};
    }
    .large {
        ${large};
    }
    a {
        ${a};
    }
    ${({ useChecklist }) =>
        !useChecklist &&
        `ul {
        ${ul};
        }
        li {
        ${li};
    }
        `}
    ol {
        ${ol};
    }
    button,
    .button {
        ${button};
    }
`;
const UserContent = ({
    content,
    className = '',
    useChecklist = false,
    checkListColumns = 2
}) => {
    let parseOptions = {};
    if (useChecklist) {
        parseOptions.replace = (node) => {
            if (node?.name === 'ul') {
                const listItemsText = map(
                    filter(node.children, { name: 'li', type: 'tag' }),
                    (child) => child.children[0].data
                );
                return (
                    <CheckList
                        {...{ items: listItemsText }}
                        columns={checkListColumns}
                    />
                );
            }
        };
    }
    return (
        <StyledDiv {...{ className, useChecklist }}>
            {formatText(content, parseOptions)}
        </StyledDiv>
    );
};

UserContent.propTypes = {
    content: PropTypes.string.isRequired,
    className: PropTypes.string,
    useChecklist: PropTypes.bool,
    checkListColumns: PropTypes.number
};

export default UserContent;
